import { render, staticRenderFns } from "./QuizStudentExam.vue?vue&type=template&id=d061373a&"
import script from "./QuizStudentExam.vue?vue&type=script&lang=js&"
export * from "./QuizStudentExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports